














































/* eslint-disable @typescript-eslint/camelcase */
import { JobTake5Hazards } from '@/models/jobTake5/jobTake5Hazards';
import { JobTake5Check } from '@/models/jobTake5/jobTake5Check';
import Nullable from '@/types/nullable';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class Take5Manage extends Vue {
  @Prop({ type: Object, default: null }) public take5!: Nullable<JobTake5Check>;

  private expanded: boolean = false;

  get lastHazardRemovable() {
    var lastHazard = this.take5.hazards[this.take5.hazards.length - 1]

    return +lastHazard.allow_custom === 1;
  }

  hazardManagable(hazardIndex: number, managableValue: boolean) {
    Vue.set(this.take5.hazards[hazardIndex], `managable`, managableValue);
  }

  addHazard() {
    var newHazard: JobTake5Hazards = {
      job_safety_take5_hazard_id: null,
      job_safety_form_id: this.take5.job_safety_take5_form_id,
      hazard_id: 13,
      Name: 'Other',
      allow_custom: true,
      custom_hazard_name: '',
      applicable: true,
      managable: null,
      control_details: null,
      control_effective: null
    }

    this.take5.hazards.push(newHazard);
  }

  removeHazard() {
    if(this.lastHazardRemovable){
      this.take5.hazards = this.take5.hazards.slice(0, -1);
    }
  }

  textRequired(v: string) {
    if (v == null || v.length == 0) {
      return "Cannot be left blank";
    }

    return true;
  }
}

